import React, { useState, useMemo } from 'react';
import { Message, Button } from 'semantic-ui-react';
import { generateNudges } from '../../utils/nudgeCalculation';

const DISMISS_STORAGE_KEY = 'dashboard_nudge_dismissed';

const getDismissedNudges = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(DISMISS_STORAGE_KEY) || '{}');
        const now = Date.now();
        // Clean expired (24h)
        const active = {};
        Object.entries(stored).forEach(([id, ts]) => {
            if (now - ts < 14 * 24 * 60 * 60 * 1000) active[id] = ts;
        });
        return active;
    } catch { return {}; }
};

const dismissNudge = (id) => {
    const dismissed = getDismissedNudges();
    dismissed[id] = Date.now();
    localStorage.setItem(DISMISS_STORAGE_KEY, JSON.stringify(dismissed));
};

const typeColorMap = {
    warning: { bg: '#fff3cd', border: '#ffc107', icon: 'warning sign' },
    info: { bg: '#d1ecf1', border: '#17a2b8', icon: 'info circle' },
};

const DashboardNudges = ({ assessments, streakData, goals, onStartRecording }) => {
    const [dismissedIds, setDismissedIds] = useState(() => Object.keys(getDismissedNudges()));

    const nudges = useMemo(() => {
        const all = generateNudges(assessments, streakData, goals);
        return all.filter(n => !dismissedIds.includes(n.id));
    }, [assessments, streakData, goals, dismissedIds]);

    if (nudges.length === 0) return null;

    const handleDismiss = (id) => {
        dismissNudge(id);
        setDismissedIds(prev => [...prev, id]);
    };

    return (
        <div style={{ marginBottom: '20px' }}>
            {nudges.map(nudge => {
                const colors = typeColorMap[nudge.type] || typeColorMap.info;
                return (
                    <Message
                        key={nudge.id}
                        style={{
                            backgroundColor: colors.bg,
                            borderLeft: `4px solid ${colors.border}`,
                            fontFamily: 'Montserrat',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '12px 15px'
                        }}
                        onDismiss={() => handleDismiss(nudge.id)}
                    >
                        <span style={{ fontSize: '20px', marginRight: '12px' }}>{nudge.icon}</span>
                        <div style={{ flex: 1 }}>
                            <strong style={{ fontSize: '14px' }}>{nudge.title}</strong>
                            <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#555' }}>{nudge.message}</p>
                        </div>
                        {nudge.actionLabel && nudge.actionType === 'startRecording' && onStartRecording && (
                            <Button
                                size="small"
                                style={{
                                    backgroundColor: colors.border,
                                    color: 'white',
                                    fontFamily: 'Montserrat',
                                    marginLeft: '12px',
                                    whiteSpace: 'nowrap'
                                }}
                                onClick={() => onStartRecording(nudge.sessionType)}
                            >
                                {nudge.actionLabel}
                            </Button>
                        )}
                    </Message>
                );
            })}
        </div>
    );
};

export default DashboardNudges;
